import { useTranslation } from "react-i18next";
import useAppSelector from "@/core/helpers/useAppSelector";
import useGetServerDateAndTime from "@/core/helpers/useGetServerDateAndTime";
import InviteModal from "@/shared/widgets/InviteModal";
import { offerResolverSelector } from "@/domains/offer/slice";
import getBusinessImage from "@/domains/business/helpers/getBusinessImage";
import useOfferResolver from "@/domains/offer/hooks/useOfferResolver";
import useOfferResolverBusiness from "@/domains/offer/hooks/useOfferResolverBusiness";

export default function OfferEstateBusinessEmployeeResolverContainer({
  isShow,
}: {
  isShow: boolean;
}) {
  const { t } = useTranslation("offer");

  const offerResolver = useAppSelector(offerResolverSelector);

  const { pending, resolveAccept, reject } = useOfferResolver();
  const { pending: loading, business } = useOfferResolverBusiness(isShow);

  const serverTime = useGetServerDateAndTime(isShow);

  const viewText = business
    ? t("offer.inviteModal.business.invite", { business: business?.name })
    : "";

  const viewDate = serverTime
    ? `${serverTime?.dayStr}.${serverTime?.monthStr}.${serverTime?.year}`
    : "";

  const icon = (
    <div
      className="w-[8.375rem] h-7.5 my-3"
      style={{
        backgroundImage: `url(${getBusinessImage(business?.id, "logo")})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      }}
    />
  );

  return (
    <InviteModal
      src={getBusinessImage(business?.id)}
      title={t("offer.inviteModal.business.title")}
      open={isShow}
      onClose={reject}
      onApply={resolveAccept}
      onDismiss={reject}
      viewHeaderAccent={t("offer.inviteModal.business.businessOwner")}
      viewHeader={offerResolver?.baseCharacter?.name}
      viewTextAccent="Должность будет добавлена позже (?????)"
      viewText={viewText}
      viewDate={viewDate}
      icon={icon}
      dataMzAccent="lightBlue"
      pending={pending || loading || !viewDate}
    />
  );
}
